module.exports = __webpack_public_path__ + "img/usersicon.66815f2b.svg";